import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getMessaging } from 'firebase/messaging';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAkLL5iht8SIe3Z0oNtwSrlRSDp7P1DQjc",
  authDomain: "fastpos-18067.firebaseapp.com",
  projectId: "fastpos-18067",
  storageBucket: "fastpos-18067.firebasestorage.app",
  messagingSenderId: "416064377501",
  appId: "1:416064377501:web:931987bae1ed5c52ad3a74",
  measurementId: "G-F7LG1JEEGM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const database = getDatabase(app);
const messaging = getMessaging(app);

// Export initialized Firebase services
export { db, database, messaging };
